import { ListItem, Skeleton } from '@mui/material';
import type { FC } from 'react';

type Props = {
  nb?: number;
};

export const SkeletonItems: FC<Props> = (props) => {
  const { nb = 5 } = props;
  return (
    <>
      {Array.from(Array(nb).keys()).map((ar) => (
        <ListItem key={ar}>
          <Skeleton width="100%" variant="text" sx={{ fontSize: '1rem' }} />
        </ListItem>
      ))}
    </>
  );
};
